import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormUgcSection from "../../components/ugc/FormUgcSection";
import { useGetUgcSection } from "../../hooks/ugc/useGetUgcSection";
import { useUpdateUgcSection } from "../../hooks/ugc/useUpdateUgcSection";

const UgcSection = () => {
    const { ugcSection, isLoading: isFetching } = useGetUgcSection();
    const { mutate, isPending: isUpdating } = useUpdateUgcSection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormUgcSection
                currentData={ugcSection}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default UgcSection;
